import { defineStore } from 'pinia'

type Cred = { username: string; password: string }

export const useAuthStore = defineStore('auth', {
  state: () => ({
    username: '' as string,
    password: '' as string,
  }),
  getters: {
    authHeader: (s) => (s.username && s.password ? 'Basic ' + btoa(`${s.username}:${s.password}`) : ''),
    isAuthenticated: (s) => !!(s.username && s.password),
  },
  actions: {
    loadFromSession() {
      const raw = sessionStorage.getItem('adminBasic')
      if (raw) {
        const { username, password } = JSON.parse(raw) as Cred
        this.username = username
        this.password = password
      }
    },
    login(username: string, password: string) {
      this.username = username
      this.password = password
      sessionStorage.setItem('adminBasic', JSON.stringify({ username, password }))
    },
    logout() {
      this.username = ''
      this.password = ''
      sessionStorage.removeItem('adminBasic')
    },
  },
})
